import { render, staticRenderFns } from "./GameDetail.vue?vue&type=template&id=798dc461&scoped=true"
import script from "./GameDetail.vue?vue&type=script&lang=js"
export * from "./GameDetail.vue?vue&type=script&lang=js"
import style0 from "./GameDetail.vue?vue&type=style&index=0&id=798dc461&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "798dc461",
  null
  
)

export default component.exports